import './RichTextBubble.css';
import React from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { get } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
var RichTextBubble = function RichTextBubble(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var textValue = get(fields, 'text.value', '');
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: textValue ? {} : {
      display: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(StyledWrapper, {
    className: "rich-text",
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper rich-text__inner",
    dangerouslySetInnerHTML: {
      __html: textValue
    }
  })))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, children);
};
var commonStyles = "cldlv36";
var ltrStyles = "l1cuqpwr";
var rtlStyles = "rbpwbrr";
export default RichTextBubble;